module.exports = __webpack_public_path__ + "img/header_left_bg.43d1f009.png";